/**
 * This function takes a string argument and returns an integer.
 * If the given integer is null or empty or an invalid integer the provided default value is returned.
 * The default value if omitted or invalid is defaulted to 0.
 *
 * @param {Number} bytes
 *
 * @returns {String}
 */

export function formatFileSize(bytes):string {
    const KB_THRESHOLD = 1024; // Threshold for switching to KB
    const MB_THRESHOLD = 1024 * 1024; // Threshold for switching to MB

    if (bytes < KB_THRESHOLD) {
        // Less than 1 KB, return as bytes
        return `${bytes} bytes`;
    } else if (bytes < MB_THRESHOLD) {
        // Less than 1 MB, convert to KB
        const kilobytes = (bytes / KB_THRESHOLD).toFixed(2);
        return `${kilobytes} KB`;
    } else {
        // Greater than or equal to 1 MB, convert to MB
        const megabytes = (bytes / MB_THRESHOLD).toFixed(2);
        return `${megabytes} MB`;
    }
}